import { useCallback } from 'react';
import { getPaymentProvider } from '@/lib/paymentProvider';
import { usePaddle } from './usePaddle';
import { usePolar } from './usePolar';
import type { CheckoutData } from '@/lib/api';

interface UsePaymentCheckoutOptions {
  onCheckoutComplete?: () => void;
  onCheckoutClosed?: () => void;
}

export function usePaymentCheckout(options: UsePaymentCheckoutOptions = {}) {
  const paddle = usePaddle(options);
  const polar = usePolar();
  const provider = getPaymentProvider();

  const openCheckout = useCallback(async (data: CheckoutData) => {
    if (provider === 'polar' && data.checkout_url) {
      await polar.openCheckout(data.checkout_url);
    } else if (data.price_id) {
      await paddle.openCheckoutWithItems({
        priceId: data.price_id,
        customData: data.custom_data,
      });
    } else if (data.transaction_id) {
      await paddle.openCheckout({
        transactionId: data.transaction_id,
      });
    }
  }, [provider, paddle, polar]);

  return { openCheckout };
}
